<template>
  <div>
    <!-- 小banner图 -->
    <div class="floor-box" v-if="centerImg">
      <img  class="banner-img"
            :src="this.centerImg"
            :onerror="errorImg" />
    </div>
    <!-- v-lazy="item.cover_pic" -->
    <!-- 好物推荐 -->
    <div class="banner-box"  v-if="goods_list.length!=0">
      <div class="banner-left" @click="listrouter()">
         <img  
            src="../../../../../src/assets/purchase/image/index/haowu@2x.png"
            :onerror="errorImg" />
      </div>
       <div class="banner-swiper">
          <div class="swiper" style="display: flex;overflow-x: auto;">
            <div v-for="(item,index) in goods_list" :key="index" style="width: 20%; margin-top:23px ;">
              <div class="item">
                 <div @click="qylist(item.id)" class="item-p">
                    <img class="img-default item-img"
                        v-lazy="item.cover_pic"
                        :onerror="errorImg" />
                        <img class="img-default-img" v-if="item.is_hot=='1'" src="../../../../../src/assets/purchase/image/index/baokuan.png" alt="">
                    <div class="name"
                        v-text="item.name"></div>
                        <div class="pic1" style="margin-left: 10px;"
                        ><span style="font-weight: 500;text-decoration: line-through;font-size: 12px;color: #333333;">京东￥{{item.jd_price}}</span></div>
                    <div class="pic" style="margin-left: 10px;font-weight: 500;color: #CC0000;font-size: 14px;"
                        >折扣价￥<span style="font-weight: 800;color: #CC0000;font-size: 20px;">{{Math.trunc(item.price)}}.</span><span style="font-weight: 500;color: #CC0000;font-size: 14px;">{{item.price.split('.')[1]}}</span></div>
                 </div>
              </div>
            </div>
  
            <!-- <view @tap="prevSwiper" class="icon-arrow arrow-left">
              <u-icon name="arrow-left" color="#ffffff" size="28"></u-icon>
            </view>
            <view @tap="nextSwiper" class="icon-arrow arrow-right">
              <u-icon name="arrow-right" color="#ffffff" size="28"></u-icon>
            </view> -->
          </div>


       </div>
		 </div> 
    <!-- 排行榜  热评   品牌 -->
    <div class="banner-top">
      <div class="banner-top-one" >
          <p >排行榜</p>
          <div class="top-one" v-for="(item,index) in top_list.slice(0,4)" :key="index" @click="qylist(item.id)">
           
            <img class="icon" :src="require(`../../../../assets/purchase/image/index/${index}.png`)">
            <img class="center-img"
                        v-lazy="item.cover_pic"
                        :onerror="errorImg" />
            <div>
              <div class="center-name"
                        v-text="item.name"></div>
              <div class="center-pic"
                 >单价<span style="font-weight: 500;color: #CC0000;font-size: 12px;">￥</span>
                 <span style="font-weight: 800;color: #CC0000;font-size: 16px;">{{Math.trunc(item.price)}}.</span>
                 <span style="font-weight: 500;color: #CC0000;font-size: 12px;">{{item.price.split('.')[1]}}</span>
              </div>
            </div>
          </div>
       
      </div>
      <div class="banner-top-two">
        <div style="display: flex; margin:22px 0 0 15px">
          <img src="../../../../assets/purchase/image/index/yushouhuore@2x.png" alt="" class="repin">
          <p>热评商品</p>
        </div>
     
          <div >
            <div v-for="(item,index) in hot_review_list.slice(0,1)" :key="index" class="top-two-img" @click="qylist(item.id)">
              <img v-lazy="item.cover_pic"  alt=""  style="width: 190px;height: 190px;margin:0 auto">
              <img class="img-default-img" v-if="item.is_hot=='1'" src="../../../../../src/assets/purchase/image/index/baokuan.png" alt="">
            </div>
            <div class="" style="width: 95%;margin: 35px auto; display: flex; flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
              <div v-for="(item,index) in hot_review_list.slice(0,4)" :key="index" class="top-two-main" @click="qylist(item.id)">
                <div class="top-two-content">
                    <img v-lazy="item.cover_pic"  alt="" class="top-two-img-img">
                   
                    <div style="padding: 0px 5px;">
                      <div class="center-name" style="width: 100%;overflow:hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;display: -webkit-box; -webkit-box-orient: vertical;"
                              v-text="item.name"></div>
                    <div class="center-pic" style="margin-top: 12px;"
                      ><span style="font-weight: 800;color: #CC0000;font-size: 12px;">￥</span>
                      <span style="font-weight: 800;color: #CC0000;font-size: 16px;">{{Math.trunc(item.price)}}.</span>
                      <span style="font-weight: 500;color: #CC0000;font-size: 12px;">{{item.price.split('.')[1]}}</span>
                    </div>
                    </div>
                </div>
              
              </div>
            </div>
            
            
          </div>
      </div>
      <div class="banner-top-three">
          <p >品牌推荐</p>
          <div class="three-cnter">
            <div v-for="(item,index) in brand_list.slice(0,12)" :key="index" class="img">
              <div>
                <img class="pic-img"
                        v-lazy="item.pic_url"
                        :onerror="errorImg" />
              </div>
              <div class="pic-font">{{item.name}}</div>
            </div>
          </div>
       
      </div>
        
    </div>
    <!-- 为你推荐 -->
    <!-- <div class="floor-box w" -->
         <!-- v-for="(value,key,index) in floor_list" -->
         <!-- :key='index'> -->
      <!-- <div class="d-flex floor-title justify-content-between align-items-center"> -->
        <!-- <h4 v-text="value.name"></h4> -->
      <!-- </div> -->
      <!-- <div class="floor-content"> -->
        <!-- <div class="advert">
					<template v-if="value.pc_advert_url == null">
						<img class="img-default" :src="value.big_pic_url" alt />
					</template>
					<template v-if="value.pc_advert_url != null">
						<template v-if="value.pc_advert_url.indexOf('http') != -1">
							<a :href="value.pc_advert_url" target="_blank"><img class="img-default" :src="value.big_pic_url" alt /></a>
						</template>
						<template v-else>
							<router-link :to="value.pc_advert_url"><img class="img-default" :src="value.big_pic_url" alt /></router-link>
						</template>
					</template>
				</div> -->
        <!-- <div> -->
          <!-- <div class="list"> -->
            <!-- <div class="item" -->
                 <!-- v-for="(item,index) in value.goods_list" -->
                 <!-- :key="index"> -->
              <!-- <span @click="qylist(item.id)"> -->
                <!-- <img class="img-default item-img" -->
                     <!-- v-lazy="item.cover_pic" -->
                     <!-- :onerror="errorImg" /> -->
                <!-- <div class="name show-two-lines" -->
                     <!-- v-text="item.name"></div> -->
                <!-- <div class="pic" -->
                     <!-- v-text="'单价'+item.price"></div> -->
              <!-- </span> -->
            <!-- </div> -->
          <!-- </div> -->
        <!-- </div> -->
      <!-- </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
// import vueSeamlessSrcoll from "vue-seamless-scroll"
export default {
  // components:{
  //   vueSeamlessSrcoll
  // },
  props: {
    centerImg:{
      type:String,
    },
    floor_list: {
      type: Array,
      default() {
        return {}
      }
    },
    goods_list: {
      type: Array,
      default() {
        return {}
      }
    },
    top_list: {
      type: Array,
      default() {
        return {}
      }
    },
    hot_review_list:{
      type: Array,
      default() {
        return {}
      }
    },
    brand_list:{
      type: Array,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      imgArr: [
      {imgSrc: require('../../../../assets/purchase/image/index/0.png')},
      {imgSrc: require('../../../../assets/purchase/image/index/1.png')},
      {imgSrc: require('../../../../assets/purchase/image/index/2.png')},
      {imgSrc: require('../../../../assets/purchase/image/index/3.png')},
    ],
    
      list:[],
      swiper_current: 0,

      route_url: this.$route.params.route_url,
      errorImg:
        'this.src="' + require('../../../../assets/images/lodingsb.svg') + '"' //图片加载失败
    }
  },
  watch: {
    floor_list: function(newValue) {}
  },
  mounted(){
    console.log(this.centerImg,'123')
  },

  methods: {
     //上一页
     prevSwiper() { 
			let current = this.swiper_current;
			let ncurrent = current > 0 ? current - 1 : this.list.length - 1;
			this.swiper_current = ncurrent
			console.log(this.swiper_current)
		},
		// 下一页
		nextSwiper() {
			let current = this.swiper_current;
			let ncurrent = current < (this.list.length - 1) ? current + 1 : 0;
			this.swiper_current = ncurrent
			console.log(this.swiper_current)
		},
  // 好物推荐点击跳转列表
    listrouter() {
				let url = this.$router.resolve({
					path:this.common.qycgrouter(this) + '/qycglist',
					// query: {
					// 	is_rec: 1
					// }
				})
				window.open(url.href);
			},

    qylist(id) {
      let url = this.$router.resolve({
        path: this.common.qycgrouter(this) + '/qycgdetails',
        query: {
          id: id
        }
      })
      // console.log(this.common.qycgrouter(this))
      // console.log(url)
      window.open(url.href)
    }
    // floorTab(index) {
    // 	this.param.active_index = index;
    // }
  }
}
</script>

<style lang="scss" scoped>
.floor-box {
  margin-top: 20px;
 
  .banner-img{
    height: 149px;
  }
}
.banner-top{
  margin-top: 20px;
  display: flex;
  width: 100%;
 
  
.banner-top-one{
  width: 33%;
  height: 440px;
  background:linear-gradient(180deg, rgba(255,255,255,0.5) 0%, #FFFFFF 100%);
  border: 1px solid #FFFFFF;
  margin-right: 15px;
  p{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    margin:22px 0 0 15px ;
  }
  .top-one{
    display: flex;
    margin-top: 17px;
    .icon{
      width: 30px;
      height: 30px;
      padding: 20px 12px 0 22px;
    }
    .center-img{
      width: 70px;
      height: 70px;
    }
    .center-name{
      font-size: 10px;
      font-weight: 400;
      color: #666666;
      margin: 0 14px;
    }
    .center-pic{
      font-size: 10px;
      font-weight: 400;
      color: #666666;
      margin: 4px 14px;
    }
  }
}
.banner-top-two{
  width: 33%;
  height: 440px;
  background:linear-gradient(180deg, rgba(255,255,255,0.5) 0%, #FFFFFF 100%);
  border: 1px solid #FFFFFF;
  margin-right: 15px;
  .repin{
    width: 18px;
    height: 18px;
    padding-top: 5rpx;
  }
  p{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    margin:0px 0 0 5px ;
  }
  .top-two-img{
    width:100%;
    height:150px;
    position: relative;
    .img-default-img{
          width: 34px;
          height: 34px;
          position: absolute;
          top: -9px;
          right: 20px;
        }
  }
  .top-two-main{
    width: 48%;
    margin-top: 20px;
    // display:flex;
    // justify-content: space-between;
    // flex-wrap: wrap;
    .top-two-content{
    display: flex;
    // justify-content: space-between;
    // flex-wrap: wrap;
  }
  }
  
  .top-two-img-img{
    width: 70px;
    height: 70px;
  }
}
.banner-top-three{
  width: 33%;
  height: 440px;
  background:linear-gradient(180deg, rgba(255,255,255,0.5) 0%, #FFFFFF 100%);
  border: 1px solid #FFFFFF;
  .three-cnter{
    display: flex;
    // justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
        // flex-wrap: wrap;
    justify-content: start;
    justify-content: space-between;
    // margin-left: 24px;
    .img{
      width: 33%;
      height: 60px;
      margin-top: 25px;
    //  margin: 0 auto;
    .pic-img{
      width: 59px;
      height: 50px;
      margin: 0 auto;
      object-fit: contain;
    }
    .pic-font{
      font-size: 10px;
      color: #333333;
      margin-top: 14px;
      // margin-left: 15px;
      text-align: center;
    }
  }  
  }
  p{
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    margin:22px 0 0 15px ;
  }

  
}
}
.banner-box{
  margin-top: 20px;
  display: flex;
  width: 100%;
  .banner-left{
    width:190px !important;
    height:276px !important;
  }
 
  .banner-swiper{
    width:calc(100% - 190px);
    background:#fff;
    .item{
      cursor: pointer;
      background-color: #fff;
      margin: 10px 16px 0 0px;
      box-sizing: border-box;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      // position:re
      
      &:nth-child(5n) {
        margin-right: 0;
      }
      .item-p{
        position: relative;
        .name{
          width: 100%;
          margin-top: 10px;
          margin-left: 10px;
          color: #666666;
          font-size: 12px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin-bottom: 10px;
          // overflow: hidden;
          // text-overflow: ellipsis;
          // white-space: nowrap;
        }
        .img-default-img{
          width: 34px;
          height: 34px;
          position: absolute;
          top: -9px;
          right: 10px;
        }
        img{
          width: 140px;
          height:140px;
          margin: 0 auto;
        }
      }
        
      
      // &:hover {
      //   box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      // }
    }
  }
  
}
.floor-title {
  padding: 17px 0 7px;
  h4 {
    font-weight: 500;
    font-size: 28px;
    color: #333333;
    line-height: 28px;
  }
  ul {
    li {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
      margin-left: 24px;
      transition: color 0.3s;
      cursor: pointer;
    }
    li:hover,
    li.active {
      color: #ff0e25;
      font-weight: 500;
    }
    li:first-child {
      margin-left: 0;
    }
  }
}
.floor-content {
  display: flex;
  // justify-content: space-between;
  .advert {
    margin-top: 10px;
    width: 250px;
    height: 590px;
    background: #cccccc;
    cursor: pointer;
    overflow: hidden;
    img {
      width: 100%;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
    }
    img:hover {
      transform: scale(1.1);
    }
  }
  .list {
    // width: 940px;
    display: flex;
    flex-wrap: wrap;
    .item {
      cursor: pointer;
      width: 225px;
      height: 290px;
      background-color: #fff;
      margin: 10px 16px 0 0px;
      padding: 15px;
      box-sizing: border-box;
      transition: 0.5s;
      -moz-transition: 0.5s;
      -webkit-transition: 0.5s;
      -o-transition: 0.5s;
      &:nth-child(5n) {
        margin-right: 0;
      }
      &:hover {
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      }

      .item-img {
        width: 195px;
        height: 195px;
      }

      .pic {
        font-size: 16px;
        color: #ff4300;
        margin-top: 4px;
        text-align: center;
      }

      .name {
        font-size: 12px;
        font-weight: 400;
        color: #666666;
        line-height: 18px;
        height: 36px;
        margin-top: 10px;
        text-align: center;
      }

      .label {
        margin-top: 8px;
        max-height: 44px;
        overflow: hidden;
        span {
          min-width: 32px;
          padding: 0px 4px;
          border-radius: 3px;
          border: 1px solid #ff0e25;
          box-sizing: border-box;
          display: inline-block;
          color: #ff0e25;
          margin: 0 4px 4px 0;
        }
      }
    }
  }
}
</style>
